export function projectConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    indexWidth: 35,
    refreshBtn: true,
    selection: false,
    selectionWidth: 30,
    searchShow: false,
    showSummary: true,
    column: [
      {
        label: "被投公司名称",
        prop: "companyName",
        searchLabelWidth: 90,
        width: "160",
      }, {
        label: '投资主体',
        search: true,
        slot: true,
        prop: 'fundName'
      },{
        label: '基金管理人',
        prop: 'managerName',
      }, {
        label: '成立国家/地区',
        prop: 'country',
        width: '120',
      }, {
        label: "所属行业",
        search: true,
        type: 'select',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=industry_type_all",
        prop: 'industry',
        width: '160',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: "string",
      }, {
        label: '投资日期',
        prop: 'investDate',
        search: true,
        searchslot: true,        
        width: '90',
      }, {
        label: '投资金额(万元)',
        prop: 'investAmount',
        formatter: (row, value, label, column) => {
          return value == -1 ? "-" : getMoney(Math.round(Number(value)/10000*100)/100);
        },        
      }, {
        label: '更新时间',
        prop: 'updateTime',
      }]
  }
}

export function detailFormConfig(getMoney) {
  return [{
    label: '被投资公司',
    prop: "companyName",
    span: 8
  },{
    label: '投资主体',
    prop: "fundName",
    span: 8
  },{
    label: '基金管理人',
    prop: "managerName",
    span: 8
  },{
    label: '成立国家/地区',
    prop: "country",
    span: 8
  },{
    label: '所属行业',
    prop: "industryStr",
    span: 8
  },{
    label: '持股比例',
    prop: "stockRatio",
    span: 8,
    unit: '%'
  },{
    label: '投资日期',
    prop: "investDate",
    span: 8
  },{
    label: '投资金额',
    prop: "investAmount",
    span: 8,
    formatter: (label, value) => {
      return `${getMoney(Number(value))}元`
    },
    unit: '元'
  },{
    label: '剩余投资本金',
    prop: "surplusInvestPrincipal",
    span: 8,
    formatter: (label, value) => {
      return `${getMoney(Number(value))}元`
    },
    unit: '元'
  },{
    label: '投资收益',
    prop: "investIncome",
    span: 8,
    formatter: (label, value) => {
      return `${getMoney(Number(value))}元`
    },
    unit: '元'
  },{
    label: '同一轮其他投资人',
    prop: "otherStock",
    span: 8
  },{
    label: '本基金投资轮次',
    prop: "investRound",
    span: 8
  },{
    label: '投后估值',
    prop: "stockValuation",
    span: 8,
    formatter: (label, value) => {
      return `${getMoney(Number(value))}元`
    },    
    unit: '元'
  },{
    label: '更新时间',
    prop: "updateTime",
    span: 16
  },{
    label: '董事/观察员席位：',
    prop: "director",
    span: 24
  },{
    label: '公司概况',
    prop: "companyProfile",
    span: 24
  },{
    label: '行业概况',
    prop: "industryProfile",
    span: 24
  },{
    label: '本报告期内的经营状况及财务状况',
    prop: "financialCondition",
    span: 24
  },{
    label: '投后管理情况',
    prop: "investPostCondition",
    span: 24
  },{
    label: '最新估值及退出计划',
    prop: "quitPlan",
    span: 24
  },{
    label: '主要风险提示',
    prop: "risk",
    span: 24
  },{
    label: '其它重要事项',
    prop: "otherMatter",
    span: 24
  }]
}